import React from 'react'
import PropTypes from 'prop-types'
import {
  Card, Row, Col, Skeleton, Button,
} from 'antd'
import { LeftOutlined } from '@ant-design/icons'
import history from 'utils/history'

const DetailNewsPage = ({
  data,
}) => (
  <div className="pb-5">
    {data.isFetching
      ? (
        <Card className="mb-3">
          <div>
            <Skeleton active />
          </div>
        </Card>
      ) : (
        <React.Fragment>
          <div className="mb-4">
            <Button type="primary" className="font-weight-bold" onClick={() => window.history.back()}>
              <LeftOutlined />
              Go Back
            </Button>
          </div>
          <Card className="mb-3">
            <Row gutter={[24, 6]}>
              <Col span={24}>
                <h5 className="mb-4">News Detail</h5>
              </Col>
              <Col span={12}>
                <p className="mr-3 mb-1 font-weight-bold">Title</p>
                <p style={{ fontSize: '16px' }}>
                  {data.detail.title || '-'}
                </p>
              </Col>
              <Col span={12} className="mb-4">
                <p className="mr-3 mb-1 font-weight-bold">Image</p>
                <img src={data.detail.image_name} className="img-landscape-300" alt="no-img" />
              </Col>
              <Col span={12}>
                <p className="mr-3 mb-1 font-weight-bold">Pembuat</p>
                <p style={{ fontSize: '16px' }}>
                  {data?.detail?.creator?.name || '-'}
                </p>
              </Col>
              <Col span={12}>
                <p className="mr-3 mb-1 font-weight-bold">Editor</p>
                <p style={{ fontSize: '16px' }}>
                  {data?.detail?.editor?.name || '-'}
                </p>
              </Col>
              <Col span={12}>
                <p className="mr-3 mb-1 font-weight-bold">Urutan ke</p>
                <p style={{ fontSize: '16px' }}>
                  {data.detail.order_no || '-'}
                </p>
              </Col>
              <Col span={12}>
                <p className="mr-3 mb-1 font-weight-bold">Is Top</p>
                <p style={{ fontSize: '16px' }}>
                  {data.detail.is_top || '-'}
                </p>
              </Col>
              <Col span={12}>
                <p className="mr-3 mb-1 font-weight-bold">Published Date</p>
                <p style={{ fontSize: '16px' }}>
                  {data.detail.published_at || '-'}
                </p>
              </Col>
              <Col span={12}>
                <p className="mr-3 mb-1 font-weight-bold">Expired Date</p>
                <p style={{ fontSize: '16px' }}>
                  {data.detail.expired_at || '-'}
                </p>
              </Col>
              <Col span={12}>
                <p className="mr-3 mb-1 font-weight-bold">Status</p>
                <p style={{ fontSize: '16px' }}>
                  {data.detail.status || '-'}
                </p>
              </Col>
              <Col span={12}>
                <p className="mr-3 mb-1 font-weight-bold">Deskripsi Singkat</p>
                <p style={{ fontSize: '16px' }}>
                  {data.detail.excerpt || '-'}
                </p>
              </Col>
              <Col span={24}>
                <p className="mr-3 mb-2 font-weight-bold">Content</p>
                <Card>
                  <div dangerouslySetInnerHTML={{ __html: data.detail.content || '-' }} />
                </Card>
              </Col>
            </Row>
          </Card>

        </React.Fragment>
      )}
  </div>
)

DetailNewsPage.propTypes = {
  data: PropTypes.object,
}

export default DetailNewsPage
